module.exports = __webpack_public_path__ + "static/media/TS.a464f05e.png";